export default "__VITE_PUBLIC_ASSET__0362a119__"